export const contentBlockType = {
  DEFAULT: 'DEFAULT',
  PAGINABLE: 'PAGINABLE',
  SCROLLABLE: 'SCROLLABLE'
};
